import React from 'react'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import Enrollaction from '../Components/Enrollaction/Enrollaction'
import Partnersec from '../Components/Partnersec/Partnersec'
import Courseonline from '../Components/Courseonline/Courseonline'
import Accordion from 'react-bootstrap/Accordion'

const Courseforonline = () => {
  return (
    <div>
        <Header/>
        <main>
            <section className='section-banner pg-banner mb-5 p-lg-5 pt-4'>
                    <div class="container text-center">
                          <div class="row justify-content-around ">
                              <div class="col-md">
                              <div class="pg-title-sec p-lg-5 p-4 bg-3 dark-bg">
                                    <h1 className='pg-title pb-3'>VLSI Courses for Online</h1>
                                    <p className='pg-title-desc mb-lg-5'>Takshila VLSI institute is among the top 10 VLSI training institutes in India. At Takshila, we understand the changing demands in the field of VLSI.
                                    </p>
                                </div>
                              </div>
                          </div>
                    </div>
            </section> 
            <section className='course-list bg-14'>
              <div class="container text-center">
                  <div class="row align-items-start">
                    <div class="col-lg">
                    <Courseonline/>
                    </div>
                  </div>
                </div>
            </section>
            <section className=''>
             <div class="faq-section ws-section pb-lg-5">
                <div class="container">
                    <div class="row pb-5">
                        <h2 class="ws-section_heading">FAQs</h2>
                        <div class="col-lg-12 align-self-center">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>1. Can I learn advanced semiconductor design skills through online training?</Accordion.Header>
                                <Accordion.Body>
Yes. Online training can provide structured learning, practical assignments, and project-based experience that help learners build industry-relevant skills from anywhere.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>2. How do I choose the right online specialization for my career goals?</Accordion.Header>
                                <Accordion.Body>
Consider your interests, academic background, and preferred career path. Different specializations focus on design, verification, testing, layout, or FPGA development.
                               </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>3. Are online technical courses suitable for fresh graduates?</Accordion.Header>
                                <Accordion.Body>
Yes. Many online programs are designed for beginners and provide a step-by-step learning path that helps fresh graduates develop practical knowledge and confidence.
                             </Accordion.Body>
                            
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>4. What should I look for before enrolling in an online training program?</Accordion.Header>
                                <Accordion.Body>
Look for experienced instructors, hands-on projects, tool access, mentorship, career support, and a curriculum aligned with current industry requirements.
                             </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="4">
                                <Accordion.Header>5. How important are practical projects in online learning?</Accordion.Header>
                                <Accordion.Body>
Projects help learners apply concepts to real-world scenarios, strengthen problem-solving skills, and build a portfolio that can support job applications.
                           </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="5">
                                <Accordion.Header>6. Can online learning help me transition into a semiconductor career?</Accordion.Header>
                                <Accordion.Body>
Yes. With consistent learning, practical exposure, and industry-focused training, online programs can help learners prepare for entry-level and specialized technical roles.
           </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="6">
                                <Accordion.Header>7. What makes an online learning program effective?</Accordion.Header>
                                <Accordion.Body>
An effective program combines theory, lab practice, project work, mentor guidance, and regular assessments to support long-term skill development.
                       </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="7">
                                <Accordion.Header>8. How can I evaluate whether an online course matches industry expectations?</Accordion.Header>
                                <Accordion.Body>
Review the curriculum, tools covered, project opportunities, trainer experience, and career support services. Takshila VLSI focuses on practical learning aligned with industry workflows.
</Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="8">
                                <Accordion.Header>9. Do online learners receive the same practical exposure as classroom students?</Accordion.Header>
                                <Accordion.Body>
With access to industry tools, guided labs, and project-based assignments, online learners can gain valuable hands-on experience. Takshila VLSI provides learning resources designed to support remote training.
 </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="9">
                                <Accordion.Header>10. What kind of support helps learners succeed in online technical courses?</Accordion.Header>
                                <Accordion.Body>
Regular mentor interaction, doubt-clearing sessions, project guidance, and interview preparation can significantly improve learning outcomes. Takshila VLSI includes these elements to help students stay on track.
                            </Accordion.Body>
                            </Accordion.Item>
                            </Accordion>
                        </div>
                    </div>
                    
                    
        </div>
    </div>
            </section>
        </main> 
        <Enrollaction/>
        <Partnersec/> 
        <Footer/> 
    </div>
  )
}

export default Courseforonline